import { render, staticRenderFns } from "./SyncFromMeliOrder.vue?vue&type=template&id=59623a6c&"
import script from "./SyncFromMeliOrder.vue?vue&type=script&lang=js&"
export * from "./SyncFromMeliOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports